export default "__VITE_ASSET__CRvI9WXf__"